import { defineMessages } from 'react-intl';

const prefix = 'algoliaSearchInput';

export const defined = defineMessages({
  whatAreYouLookingFor: {
    id: `${prefix}.whatAreYouLookingFor`,
    defaultMessage: 'What are you looking for?',
  },
});
